import React, {Component, ReactNode} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../shared/hoc/createAdminPage'
import {Nullable} from '../../app/TypeHelpers'
import AssocManagementRepository from './AssocManagementRepository'
import {Information} from '../../network/response/Information'
import {formatDateLocal} from '../../formatters/formatMoment'
import {AssocOfCondominium} from './model/AssocOfCondominium'
import {AssocTerm} from './model/AssocTerm'
import {AdminAssocTermForm, AdminAssocTermFormState} from './components/AdminAssocTermForm'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    location: Location<EditAssocTermLocationState>
    assocManagementRepo: AssocManagementRepository
}

export interface EditAssocTermLocationState {
    assocList: AssocOfCondominium[],
    selectedAssocId: number,
    baseAssocTermObject: object,
}

interface State {
    baseAssocTerm: AssocTerm
}

class AdminEditAssocTermPage extends Component<Props & AdminPagePropsSet, State> {
    constructor(props: Readonly<Props & AdminPagePropsSet>) {
        super(props)

        const {
            assocList,
            selectedAssocId,
            baseAssocTermObject,
        } = props.location.state

        if (!assocList) {
            throw Error('管理組合リストが渡されていない')
        }

        if (assocList.length === 0) {
            throw Error('渡された管理組合リストの中身がない')
        }

        if (!selectedAssocId) {
            throw Error('処理対象の管理組合IDが渡されていない')
        }

        if (!baseAssocTermObject) {
            throw Error('編集する期の情報が渡されていない')
        }

        const baseAssocTerm = AssocTerm.from(baseAssocTermObject)
        this.state = {
            baseAssocTerm: baseAssocTerm,
        }
    }

    handleClickPreviousPage = () => {
        this.props.navigate(
            `/admin/condominiums/${this.props.condominiumCd}/assoc-terms`,
        )
    }

    handleClickSubmit = async (state: AdminAssocTermFormState) => {
        const {
            condominiumCd,
            assocManagementRepo,
            asyncCallFunction,
            navigate,
            location,
            eventEmitter,
        } = this.props

        const {
            assocTermName,
            assocTermStartDate,
            assocTermEndDate,
        } = state

        if (assocTermStartDate === null || assocTermEndDate === null) {
            return
        }

        await eventEmitter.showLoading()
        try {
            const informations: Nullable<Information[]> = await asyncCallFunction(
                // @ts-ignore
                assocManagementRepo.updateAssocTerm.bind(
                    assocManagementRepo,
                    condominiumCd,
                    Number(location.state.selectedAssocId),
                    this.state.baseAssocTerm.assocTermId,
                    assocTermName,
                    formatDateLocal(assocTermStartDate),
                    formatDateLocal(assocTermEndDate),
                    this.state.baseAssocTerm.version,
                ),
                (httpErrorOrNetworkError) => {
                    httpErrorOrNetworkError.broadcast(eventEmitter)
                },
            )

            if (informations === null) {
                return
            }

            navigate(
                `/admin/condominiums/${condominiumCd}/assoc-terms`,
                {
                    state: {
                        selectedAssocId: location.state.selectedAssocId,
                        information: informations[0],
                    },
                },
            )
        } finally {
            eventEmitter.closeLoading()
        }
    }

    render(): ReactNode {
        const {
            condominiumCd,
            eventEmitter,
        } = this.props
        const {
            assocList,
            selectedAssocId,
        } = this.props.location.state

        return <>
            <AdminAssocTermForm
                condominiumCd={condominiumCd}
                assocList={assocList}
                selectedAssocId={selectedAssocId}
                baseAssocTerm={this.state.baseAssocTerm}
                handleClickPreviousPage={this.handleClickPreviousPage}
                handleClickSubmit={this.handleClickSubmit}
                eventEmitter={eventEmitter}
            />
        </>
    }
}

export default createAdminPage(AdminEditAssocTermPage)
